import Layout from '~/components/Layout';
import ModuleRenderer from '~/components/ModuleRenderer';
import SEO from '~/components/SEO';
import { useBranchJourney } from '~/hooks/use-branch-journey';
import { usePageLoad } from '~/hooks/use-page-load';
import { useScreenView } from '~/hooks/use-screen-view';
import type { IPageProps } from '~/pages/types';

const LandingPage = ({ request, seoMetadata }: IPageProps): JSX.Element => {
  const { onPageLoad, metadata: branchMetadata } = useBranchJourney({});
  const onScreenView = useScreenView();
  const onViewLoaded = usePageLoad([onPageLoad, onScreenView]);

  let isHomePage = false;
  if ('path' in request) {
    isHomePage = request.path !== '/';
  }

  return (
    <>
      <SEO branchMetadata={branchMetadata} seoMetadata={seoMetadata} />
      <Layout isBackButtonInLayoutHeader={isHomePage}>
        <ModuleRenderer onViewLoaded={onViewLoaded} request={request} />
      </Layout>
    </>
  );
};

export default LandingPage;
